import { render, staticRenderFns } from "./purchaseNum.vue?vue&type=template&id=61755b8e&scoped=true&"
import script from "./purchaseNum.vue?vue&type=script&lang=js&"
export * from "./purchaseNum.vue?vue&type=script&lang=js&"
import style0 from "./purchaseNum.vue?vue&type=style&index=0&id=61755b8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61755b8e",
  null
  
)

export default component.exports